import { render, staticRenderFns } from "./GeneralSection.vue?vue&type=template&id=5abe157a&scoped=true"
import script from "./GeneralSection.vue?vue&type=script&lang=js"
export * from "./GeneralSection.vue?vue&type=script&lang=js"
import style0 from "./GeneralSection.vue?vue&type=style&index=0&id=5abe157a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe157a",
  null
  
)

export default component.exports